import React, { useState, useEffect } from 'react';
import { Box, Heading, Text, VStack, Button, Flex, Spinner, Badge } from '@chakra-ui/react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaCheckCircle, FaTimesCircle, FaArrowLeft } from 'react-icons/fa';

const TakeLnaQuizResult = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const token = JSON.parse(localStorage.getItem('user'))?.token || "";

  useEffect(() => {
    const fetchResult = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/standalone-quiz/${id}/result`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setResult(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchResult();
  }, [id, token]);

  if (isLoading) {
    return <Flex justify="center" p={20}><Spinner size="xl" /></Flex>;
  }

  if (!result) {
    return (
      <Box p={10} textAlign="center">
        <Text>Result not found.</Text>
        <Button mt={4} onClick={() => navigate('/home')}>Back</Button>
      </Box>
    );
  }

  return (
    <Box maxW="800px" mx="auto" p={6} mt={10}>
      <Flex justify="space-between" align="center" mb={6}>
        <Button leftIcon={<FaArrowLeft />} variant="ghost" onClick={() => navigate('/home')}>
          Back to Dashboard
        </Button>
        <Heading size="md" color="purple.500">
          Score: {result.score} / {result.maxScore}
        </Heading>
      </Flex>

      <VStack spacing={6} align="stretch">
        {result.detailedAnswers.map((ans, idx) => (
          <Box key={idx} bg="var(--bg-surface)" p={6} borderRadius="2xl" border="1px solid rgba(255,255,255,0.05)">
            <Flex justify="space-between" mb={3}>
              <Badge colorScheme="purple">{ans.topic}</Badge>
              {ans.isCorrect ? (
                <Badge colorScheme="green" display="flex" alignItems="center" gap={1}>
                  <FaCheckCircle /> Correct
                </Badge>
              ) : (
                <Badge colorScheme="red" display="flex" alignItems="center" gap={1}>
                  <FaTimesCircle /> Incorrect
                </Badge>
              )}
            </Flex>
            
            <Heading size="md" mb={4}>{idx + 1}. {ans.questionText}</Heading>
            
            <Box mb={4} p={3} bg="whiteAlpha.50" borderRadius="md">
              <Text fontWeight="bold" color="gray.400" fontSize="sm" mb={1}>Your Answer:</Text>
              <Text color={ans.isCorrect ? "green.300" : "red.300"}>
                {ans.userAnswer ? ans.options[ans.userAnswer.replace('Option ', '')] : "No answer"}
              </Text>
            </Box>

            {!ans.isCorrect && (
              <Box mb={4} p={3} bg="green.900" borderRadius="md">
                <Text fontWeight="bold" color="green.200" fontSize="sm" mb={1}>Correct Answer:</Text>
                <Text color="green.100">
                  {ans.options[ans.correctAnswer.replace('Option ', '')]}
                </Text>
              </Box>
            )}

            <Box p={3} bg="purple.900" borderRadius="md">
              <Text fontWeight="bold" color="purple.200" fontSize="sm" mb={1}>Explanation:</Text>
              <Text color="purple.100" fontSize="sm">{ans.explanation}</Text>
            </Box>
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

export default TakeLnaQuizResult;
